import { Box } from "@chakra-ui/react"
import { FC } from "react"
import { PlansPageStyling } from "src/context/types"
import usePageStyling from "src/hooks/usePageStyling"
import useGridPageStyling from "../views/avatars/hooks/useGridPageStyling"

export const SectionContainer: FC = ({ children }) => {
  const branding = useGridPageStyling()
  const style: PlansPageStyling = usePageStyling("plansPageStyling")

  return (
    <Box
      borderRadius={style?.planPageButtonBorderRadius}
      bg={branding.panelBackgroundColor}
      px={4}
      py={3}
    >
      {children}
    </Box>
  )
}
